// extracted by mini-css-extract-plugin
export default {"modal":"MM-z","modalOverlay":"NM-z","outfitHeading":"OM-z"};